// import React, { useState } from 'react'
// import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp'
// import { CountryCode } from '../../Components/Contact/CountryCode'
// import axios from 'axios';

// export default function ContactUs() {

//     const [name, setName] = useState('');
//     const [countrycode, setCountrycode] = useState('');
//     const [number, setNumber] = useState('');
//     const [mail, setMail] = useState('');
//     const [message, setMessage] = useState('');

//     const addData = async () => {
//         // Check if any required field is empty
//         const requiredFields = [name, number, countrycode, mail];
//         const hasEmptyFields = requiredFields.some(field => field === '');
//         // setIsButtonDisabled(true);

//         if (hasEmptyFields) {
//             alert('Please fill in all required fields.');
//             return;
//         }

//         try {
//             const newData = {
//                 Name: name,
//                 Country_code: countrycode,
//                 Mobile_Number: number,
//                 Email: mail,
//                 Message_Box: message,
//             };
//             await axios.post('https://sheetdb.io/api/v1/fvphlhodwjbgi', newData);
//             setName('');
//             setCountrycode('');
//             setNumber('');
//             setMail('');
//             setMessage('');
//             // alert("Your form has been submitted successfully! Our team will contact you within 24 hours!");
//         } catch (error) {
//             console.error('Error in Submission', error);
//         }
//     };

//     return (
//         <div className='py-20'>
//             <div className='z-10'>
//                 <div className='flex xl:flex sm:block max-sm:block justify-center items-start gap-20 px-20 max-sm:px-5 py-10'>
//                     <div className='flex justify-center items-center bg-white bg-opacity-50 p-3 rounded-xl w-2/3 xl:w-2/3 sm:w-fit max-sm:w-full mx-0 xl:mx-0 sm:mx-20'>
//                         <div>
//                             <FadeInSectionDownToUp>
//                                 <div className='py-3'>
//                                     <input type='text' placeholder='Name' className='w-full px-3 py-2 rounded-md' value={name} onChange={(e) => setName(e.target.value)} />
//                                 </div>
//                                 <div className='flex space-x-3 py-3'>
//                                     <select className='w-1/4 rounded-md py-2 text-center' value={countrycode} onChange={(e) => setCountrycode(e.target.value)}>
//                                         {CountryCode.map(code => (
//                                             <option
//                                                 key={code.value}
//                                                 value={code.value}
//                                                 disabled={code.disabled}
//                                                 selected={code.selected}
//                                                 hidden={code.hidden}
//                                                 className='text-start'
//                                             >
//                                                 {code.value || code.text}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     <input type='number' placeholder='Mobile Number' className='w-full px-3 py-2 rounded-md' value={number} onChange={(e) => setNumber(e.target.value)} />
//                                 </div>
//                                 <div className='py-3'>
//                                     <input type='text' placeholder='Email ID' className='w-full px-3 py-2 rounded-md' value={mail} onChange={(e) => setMail(e.target.value)} />
//                                 </div>
//                                 <div className='py-3'>
//                                     <input type='text' placeholder='Message Box (optional)' className='w-full px-3 py-2 rounded-md' value={message} onChange={(e) => setMessage(e.target.value)} />
//                                 </div>
//                                 <center className='py-3'>
//                                     <button onClick={addData} className='bg-gray-200 hover:bg-gray-300 transition duration-500 ease-in-out shadow-lg shadow-gray-400 py-2 px-8 rounded-md'>
//                                         Submit
//                                     </button>
//                                 </center>
//                             </FadeInSectionDownToUp>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }




import React, { useState } from 'react';
import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp';
import { CountryCode } from '../../Components/Contact/CountryCode';
import axios from 'axios';
import { FaFacebookF } from 'react-icons/fa';
import { FaInstagram, FaXTwitter, FaYoutube } from 'react-icons/fa6';

export default function ContactUs() {
    const [name, setName] = useState('');
    const [countrycode, setCountrycode] = useState('');
    const [number, setNumber] = useState('');
    const [mail, setMail] = useState('');
    const [message, setMessage] = useState('');

    const addData = async () => {
        const requiredFields = [name, number, countrycode, mail];
        const hasEmptyFields = requiredFields.some(field => field === '');

        if (hasEmptyFields) {
            alert('Please fill in all required fields.');
            return;
        }

        try {
            const newData = {
                Name: name,
                Country_code: countrycode,
                Mobile_Number: number,
                Email: mail,
                Message_Box: message,
            };
            await axios.post('https://sheetdb.io/api/v1/5elucfkippn6o', newData);
            setName('');
            setCountrycode('');
            setNumber('');
            setMail('');
            setMessage('');
            alert("Your form has been submitted successfully! Our team will contact you within 24 hours!");
        } catch (error) {
            console.error('Error in Submission', error);
        }
    };

    return (
        <div
            className="bg-cover bg-center min-h-screen py-40 px-4"
            style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Home/4328380_11781.png')` }}
        >
            <div className="bg-black bg-opacity-80 max-w-6xl mx-auto rounded-2xl shadow-xl flex flex-col md:flex-row justify-between items-stretch p-10 max-sm:p-5">
                {/* Left Info Panel */}
                <div className="text-white md:w-1/2 mb-10 md:mb-0 md:pr-10">
                    <FadeInSectionDownToUp>
                        <h2 className="text-2xl text-[#FFB400] font-bold mb-4">Stay Connected</h2>
                    </FadeInSectionDownToUp>
                    <FadeInSectionDownToUp>
                        <h3 className="text-4xl font-semibold mb-4 leading-snug">We’re Always<br />Here to <span className='text-[#FF6557]'>Serve You.</span></h3>
                    </FadeInSectionDownToUp>
                    <FadeInSectionDownToUp>
                        <p className="text-lg mb-6">
                            Reach out to us anytime - your journey with AL-BIDAYAH matters to us, no matter where you are in the world.
                        </p>
                    </FadeInSectionDownToUp>
                    <FadeInSectionDownToUp>
                        <p className="text-lg mb-6">
                            Restoran AL-BIDAYAH (M) Sdn Bhd<br />
                            No. 23A, Jalan 2/14,<br />
                            Bandar Baru Selayang,<br />
                            68100 Batu Caves,<br />
                            Selangor Darul Ehsan.
                        </p>
                    </FadeInSectionDownToUp>
                    <FadeInSectionDownToUp>
                        <div className="flex gap-5 mt-4">
                            <a href="https://www.facebook.com/AlBidayahGroups/" target="_blank" rel="noopener noreferrer">
                                <FaFacebookF className="text-white text-2xl hover:text-blue-500 transition" />
                            </a>
                            <a href="https://www.instagram.com/al.bidayah.groups/" target="_blank" rel="noopener noreferrer">
                                <FaInstagram className="text-white text-2xl hover:text-pink-300 transition" />
                            </a>
                            <a href="https://x.com/AL_Bidayah_" target="_blank" rel="noopener noreferrer">
                                <FaXTwitter className="text-white text-2xl transition" />
                            </a>
                            <a href="https://www.youtube.com/@AL-BIDAYAH-Groups" target="_blank" rel="noopener noreferrer">
                                <FaYoutube className="text-white text-2xl hover:text-red-400 transition" />
                            </a>
                        </div>
                    </FadeInSectionDownToUp>
                </div>

                {/* Right Form */}
                <div
                    className="relative bg-white bg-opacity-90 backdrop-blur-md rounded-xl shadow-lg w-full md:w-1/2"
                    style={{
                        backgroundImage: "url('https://albidayahgroups.com/Media/Home/4328380_11781.png')",
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                >
                    <div className="bg-[#420110] bg-opacity-90 rounded-xl p-6">
                        <FadeInSectionDownToUp>
                            <form className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-white mb-1">Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter your name"
                                        className="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring focus:ring-gray-400"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>

                                <div className="flex gap-3">
                                    <div className="w-1/3">
                                        <label className="block text-sm font-medium text-white mb-1">Country Code</label>
                                        <select
                                            className="w-full py-2 rounded-md border border-gray-300 text-center"
                                            value={countrycode}
                                            onChange={(e) => setCountrycode(e.target.value)}
                                        >
                                            {CountryCode.map(code => (
                                                <option
                                                    key={code.value}
                                                    value={code.value}
                                                    disabled={code.disabled}
                                                    hidden={code.hidden}
                                                >
                                                    {code.value || code.text}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="w-2/3">
                                        <label className="block text-sm font-medium text-white mb-1">Mobile Number</label>
                                        <input
                                            type="number"
                                            placeholder="Enter your number"
                                            className="w-full px-3 py-2 rounded-md border border-gray-300"
                                            value={number}
                                            onChange={(e) => setNumber(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-white mb-1">Email</label>
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        className="w-full px-3 py-2 rounded-md border border-gray-300"
                                        value={mail}
                                        onChange={(e) => setMail(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-white mb-1">Message</label>
                                    <textarea
                                        placeholder="Write your message..."
                                        className="w-full px-3 py-2 h-24 rounded-md border border-gray-300 resize-none"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                </div>

                                <div className="text-center pt-4">
                                    <button
                                        type="button"
                                        onClick={addData}
                                        className="bg-[#FFB400] hover:bg-[#035469] text-white font-semibold px-6 py-2 rounded-md transition duration-300"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
            </div>
        </div>
    );
}
